import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import { TContractCategoriesList } from '../types'
import { defaultPopupWithPayload } from './constants'

type ContextProps = {
  addResponsibleUserPopup: PopupReturnTypeWithPayload<{
    selectedCC: TContractCategoriesList
  }>
}

const basePopup = (title: string) => ({
  title
})
const CategoriesPopupContext = createContext<ContextProps>({
  addResponsibleUserPopup: defaultPopupWithPayload
})

const CategoriesPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const addResponsibleUserPopupProps = usePopup<{
    selectedCC: TContractCategoriesList
  }>(basePopup('Manage category assignment'))

  const context = useMemo(
    () => ({
      addResponsibleUserPopup: addResponsibleUserPopupProps
    }),
    [addResponsibleUserPopupProps]
  )

  return (
    <CategoriesPopupContext.Provider value={context}>
      {children}
    </CategoriesPopupContext.Provider>
  )
}

export const useContractCategoryDetailsPopup = () =>
  useContext(CategoriesPopupContext)

export default CategoriesPopupProvider
